import React from 'react';
import '../../../../css/common/chat/AiFluidMark.css';

const joinClassNames = (...tokens: Array<string | false | null | undefined>) => tokens.filter(Boolean).join(' ');

export default function AiFluidMark({ className = '', variant = 'default' }) {
  return (
    <span className={joinClassNames('ai-fluid-mark', `ai-fluid-mark--${variant}`, className)} aria-hidden="true">
      <span className="ai-fluid-mark__core">
        <span className="ai-fluid-mark__blob ai-fluid-mark__blob--purple"></span>
        <span className="ai-fluid-mark__blob ai-fluid-mark__blob--green"></span>
        <span className="ai-fluid-mark__blob ai-fluid-mark__blob--blend"></span>
      </span>
    </span>
  );
}
